var React = require('react');

function TableOfContents (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0V0zm0 0h24v24H0V0z","fill":"none","key":0}),React.createElement("path",{"d":"M3 9h14V7H3v2zm0 4h14v-2H3v2zm0 4h14v-2H3v2zm16 0h2v-2h-2v2zm0-10v2h2V7h-2zm0 6h2v-2h-2v2z","key":1})]);
}

TableOfContents.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = TableOfContents;

TableOfContents.default = TableOfContents;
